import { SxProps, Theme } from '@mui/material';
import { commonStyles } from '~/theme/styles/commonStyles.ts';

export const styles: Record<string, SxProps<Theme>> = {
  container: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  containerChangePassword: (theme: Theme) => ({
    width: '550px',
    padding: '20px 80px',
    boxSizing: 'border-box',
    borderRadius: '18px',
    boxShadow: '7px 7px 40px 0 rgba(217, 217, 217, 0.8)',
    [theme.breakpoints.down('sm')]: {
      width: '300px',
      height: '250px',
      padding: '25px',
    },
  }),

  headerTextChangePassword: (theme: Theme) => ({
    textAlign: 'center',
    color: 'var(--additional-blue-dark)',
    fontSize: '28px',
    paddingBottom: '10px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '22px',
    },
  }),

  containerSignUp: (theme: Theme) => ({
    width: '550px',
    padding: '20px 80px',
    boxSizing: 'border-box',
    borderRadius: '18px',
    boxShadow: '7px 7px 40px 0 rgba(217, 217, 217, 0.8)',
    [theme.breakpoints.down('sm')]: {
      width: '300px',
      height: '510px',
      padding: '25px',
    },
  }),

  containerSignIn: (theme: Theme) => ({
    width: '550px',
    padding: '30px 70px',
    boxSizing: 'border-box',
    borderRadius: '18px',
    boxShadow: '7px 7px 40px 0 rgba(217, 217, 217, 0.8)',
    [theme.breakpoints.down('sm')]: {
      width: '300px',
      padding: '25px',
    },
  }),

  containerSignManager: (theme: Theme) => ({
    width: '550px',
    padding: '30px 70px',
    boxSizing: 'border-box',
    borderRadius: '18px',
    boxShadow: '7px 7px 40px 0 rgba(217, 217, 217, 0.8)',
    [theme.breakpoints.down('sm')]: {
      width: '300px',
      height: '250px',
      padding: '25px',
    },
  }),

  dividerContainer: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '3px',
    margin: '15px 0',
    color: theme.palette.grey.additionalGrey,
    [theme.breakpoints.down('sm')]: {
      margin: '10px 0',
    },
  }),

  divider: (theme: Theme) => ({
    flex: 1,
    borderColor: theme.palette.grey.additionalGrey,
    borderBottomWidth: '1.3px',
  }),

  dividerContainerText: (theme: Theme) => ({
    fontSize: '15px',
    padding: '0 10px',
    whiteSpace: 'nowrap',
    color: theme.palette.grey.additionalGrey,
  }),

  headerText: (theme: Theme) => ({
    textAlign: 'center',
    color: theme.palette.primary.dark,
    fontSize: '36px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '22px',
    },
  }),

  modalContainer: (theme: Theme) => ({
    ...(commonStyles.scroll(theme) as Object),
    zIndex: 2,
    width: '80%',
    overflowX: 'hidden',
  }),

  modalContent: (theme: Theme) => ({
    color: theme.palette.text.primary,
    textAlign: 'justify',
  }),

  modalContentTitle: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'center',
    color: theme.palette.text.primary,
    fontSize: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    },
  }),

  modalContentTitleText: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'center',
    fontSize: '20px',
    paddingBottom: '10px',
    color: theme.palette.primary.dark,
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    },
  }),

  textLink: (theme: Theme) => ({
    paddingBottom: '10px',
    textAlign: 'end',
    color: theme.palette.primary.dark,
  }),

  buttonGroup: {
    flexWrap: 'wrap',
    gap: '10px',
    width: '100%',
  },
};
